import LenderAdhocReporting from './LenderAdhocReporting';

export default LenderAdhocReporting;
